/**
 * Auto-seleciona quantidade baseado no parâmetro ?quantity=N da URL
 * Funciona para qualquer produto, independente do form usado
 */
(function() {
  'use strict';

  function selectQuantityFromURL() {
    try {
      const params = new URLSearchParams(window.location.search);
      const qtyParam = params.get('quantity');
      
      if (!qtyParam) return;

      const qty = parseInt(qtyParam, 10);
      if (isNaN(qty) || qty < 1) return;

      console.log('[qty-url] Attempting to select quantity:', qty);

      // Tenta múltiplos seletores comuns para quantidade
      const selectors = [
        `input[type="radio"][name="quantity"][value="${qty}"]`,
        `input[type="radio"]#qty-${qty}`,
        `input.sb_variant_option[value="${qty}"]`,
        `input[name="quantity"][value="${qty}"]`,
        `.qty-option[data-qty="${qty}"] input[type="radio"]`
      ];

      let found = false;

      for (const selector of selectors) {
        const input = document.querySelector(selector);
        if (input && input.type === 'radio') {
          // Desmarca outros do mesmo grupo
          const name = input.getAttribute('name');
          if (name) {
            document.querySelectorAll(`input[name="${CSS.escape(name)}"]`).forEach(el => {
              el.checked = false;
            });
          }

          // Marca o selecionado
          input.checked = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
          
          console.log('[qty-url] ✓ Quantity selected:', qty, selector);
          found = true;
          break;
        }
      }

      if (!found) {
        console.warn('[qty-url] Quantity input not found for:', qty);
      }

    } catch (err) {
      console.error('[qty-url] Error:', err);
    }
  }

  // Executa quando DOM estiver pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', selectQuantityFromURL);
  } else {
    selectQuantityFromURL();
  }

  // Reexecuta se a página mudar (útil para SPAs)
  if (window.history && typeof window.history.pushState === 'function') {
    const originalPushState = window.history.pushState;
    window.history.pushState = function() {
      originalPushState.apply(window.history, arguments);
      setTimeout(selectQuantityFromURL, 100);
    };
  }
})();
